export const minStepIndex = 0;
